import Field from "components/molecules/Field";
import {useForm} from "components/molecules/Form";
import Form from "components/molecules/Form/Form";
import React from "react";
import styled from "styled-components";
import UploadFile from "../../../../../../assets/uploadFile.svg";

const StyledImagesSection = styled(Form)`
    width: 100%;
    padding: 30px 15px;
    .input-field-wrap {
        .label {
            font-size: 18px;
            line-height: 22px;
            font-weight: 400;
        }
        textarea {
            min-height: 110px;
        }
        .labelButton {
            background-color: var(--white);
            border: 1px dashed rgba(205, 205, 205, 1);
            .icon-img {
                width: 35px;
            }
            .text-lg {
                color: rgba(143, 143, 143, 1);
                font-size: 12px;
                line-height: 16px;
                font-weight: 300;
                margin-bottom: 16px;
            }
            .text {
                width: max-content;
                border: 1px solid rgba(225, 228, 232, 1);
                color: var(--text-color);
                border-radius: 60px;
                padding: 10px 25px;
                font-size: 16px;
                line-height: 20px;
                font-weight: 400;
            }
        }
    }
`;

const ImagesSection = () => {
    const [form] = useForm();
    return (
        <StyledImagesSection form={form} onSubmit={e => console.log(e)}>
            <Form.Item
                label="Restaurant Name"
                type="img"
                rounded
                name="upload_image1"
                lg
                uploadTitle="Upload Restaurant Logo"
                icon={UploadFile}
                disc="Upload File"
                $bgWhite>
                <Field />
            </Form.Item>

            <Form.Item
                label="Hero Banner"
                type="img"
                rounded
                name="upload_image2"
                icon={UploadFile}
                lg
                uploadTitle="Upload Restaurant Logo"
                disc="Upload File"
                $bgWhite>
                <Field />
            </Form.Item>
        </StyledImagesSection>
    );
};

export default ImagesSection;
